<template>
  <Button
    v-if="isShow"
    :type="type"
    :disabled="disabled"
    :loading="loading"
    :icon="icon"
    :size="size"
    @click="handleClick"
  >
    <slot></slot>
  </Button>
</template>
<script>
import util from '@/assets/js/util';
export default {
  name: 'CustomButton',
  props: {
    type: {
      type: String,
      default: 'default'
    },
    disabled: {
      type: Boolean,
      default: false
    },
    loading: {
      type: Boolean,
      default: false
    },
    icon: {
      type: String,
      default: ''
    },
    size: {
      type: String,
      default: 'default'
    },
    permissionCode: {
      type: String,
      default: ''
    }
  },
  computed: {
    isShow() {
      const data = this.$store.state.permission.usePermission;
      const flag = util.checkPermissionForButton(
        data.pageComponent,
        this.permissionCode
      );
      return flag;
    }
  },
  methods: {
    handleClick() {
      this.$emit('click');
    }
  }
};
</script>
